import config from './app.config';
import app from './app.html';
import CUSTOMER_ALLOWED_STATES from './models/customerAllowedStates.js';

const CUSTOMER_ADMIN = 1;
const MHE_ADMIN = 2;
const SUPPORT_ADMIN = 4;
const SUPER_ADMIN = 42;

let configBlock = ($stateProvider, $urlRouterProvider, localStorageServiceProvider, $locationProvider, $translateProvider, IdleProvider, KeepaliveProvider, ChatScript) => {

  IdleProvider.idle(3600);
  IdleProvider.timeout(1);
  KeepaliveProvider.interval(30);

  $urlRouterProvider.otherwise('/login');

  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });

  const chatScript = new ChatScript(config);

  $stateProvider
    .state('requestPasswordReset', {
      url: '/requestPasswordReset',
      template: '<request-password-reset></request-password-reset>'
    })
    .state('login', {
      url: '/login',
      template: '<login></login>',
      params: {
        passwordUpdated: null
      }
    })
    .state('sso', {
      url: '/sso',
      views: {
        '': {
          template: '<sso></sso>'
        }
      }
    })
    .state('timeout', {
      url: '/login/timeout',
      template: '<login></login>',
      isTimeout: true
    })
    .state('home', {
      url: '',
      authRequired: true,
      onEnter: function() {
        // idempotent
        chatScript.initialize();
      },
      views: {
        '': {
          template: app
        }
      }
    })
    .state('home.dashboard', {
      url: '/dashboard',
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      template: '<dashboard></dashboard>',
      title: 'DASHBOARD_OVERVIEW'
    })
    .state('home.databrowser', {
      url: '/databrowser',
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      template: '<databrowser></databrowser>',
      title: 'DATA_BROWSER'
    })
    .state('home.batchErrors', {
      url: '/batchErrors',
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      template: '<batch-errors></batch-errors>',
      title: 'ERRORS_TITLE'
    })
    .state('home.account', {
      url: '/account/:tabName',
      authRequired: true,
      template: '<user-account></user-account>',
      title: 'ACCOUNT_SETTINGS'
    })
    .state('home.syncSettings', {
      url: '/syncSettings/:tabName',
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      template: '<sync-settings></sync-settings>',
      title: 'SYNC_SETTINGS'
    })
    .state('home.assign', {
      url: '/assign',
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      template: '<entitler></entitler>',
      title: 'ENTITLER'
    })
    .state('home.assign.assignments', {
      url: '/products/assignments/:tabName',
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      template: '<assignments></assignments>',
      title: 'ENTITLER'
    })
    .state('home.assign.productsSelector', {
      url: '/products',
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      customerRestrictions:CUSTOMER_ALLOWED_STATES.curriedStateValidation('home.assign'),
      template: '<products-selector></products-selector>',
      title: 'PRODUCT_SELECTOR'
    })
    .state('home.assign.resourceSelector', {
      url: '/products/resource',
      params:{
        data: null
      },
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      template: '<products-selector></products-selector>',
      title: 'PRODUCT_SELECTOR'
    })
    .state('home.assign.aleksMasterTemplateSelector', {
      url: '/products/aleks-master-templates',
      params: {
        resources: null,
        data: null,
      },
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      customerRestrictions: CUSTOMER_ALLOWED_STATES.curriedStateValidation('home.assign'),
      template: '<products-selector></products-selector>',
      title: 'PRODUCT_SELECTOR'
    })
    .state('home.assign.confirmation', {
      url: '/:tabName/confirmation',
      authRequired: true,
      roleRequired: [CUSTOMER_ADMIN],
      template: '<assignment-confirmation></assignment-confirmation>',
      title: 'CONFIRMATION'
    })
    .state('home.edit', {
      url: '/edit',
      authRequired: true,
      roleRequired: [MHE_ADMIN,SUPPORT_ADMIN, SUPER_ADMIN],
      template: '<edit-customers></edit-customers>',
      title: 'EDIT_CUSTOMERS'
    })
    .state('home.create', {
      url: '/create/:tabName',
      authRequired: true,
      roleRequired: [MHE_ADMIN,SUPPORT_ADMIN, SUPER_ADMIN],
      template: '<admin-create-section></admin-create-section>',
      title: 'ADMIN_CREATE_SECTION'
    })
    .state('home.tools', {
      url: '/tools',
      authRequired: true,
      params: {
        customer: null
      },
      roleRequired: [MHE_ADMIN, SUPPORT_ADMIN, SUPER_ADMIN],
      template: '<admin-tool-section></admin-tool-section>',
      title: 'ADMIN_TOOLS'
    })
    .state('passwordReset', {
      url: '/passwordReset',
      authRequired: false,
      template: '<password-reset></password-reset>'
    })
    .state('default', {
      url: '',
      views: {
        '': {
          template: app
        }
      }
    });

  localStorageServiceProvider
    .setPrefix(config.storage.prefix)
    .setStorageType(config.storage.storageType)
    .setNotify(true, true);

  $translateProvider.useStaticFilesLoader({
    prefix: config.localization.filePrefix,
    suffix: config.localization.fileSuffix
  });

  $translateProvider.preferredLanguage(config.localization.defaultLanguage);
  $translateProvider.useSanitizeValueStrategy('escapeParameters');
  appendCacheBustToSrcTags();
};

function appendCacheBustToSrcTags() {
  var scripts = document.getElementsByTagName('script');
  var newAppBundle,oldScriptIndex,oldAppBundle;

  for (var i = 0; i < scripts.length; i++) {
    let scriptSrc = scripts[i].src;
    let appBundle = scriptSrc.match(/app.*.bundle.js/);
    oldScriptIndex = -1;

    if (appBundle && appBundle.index && appBundle.index > -1) {
      newAppBundle = document.createElement('script');
      oldScriptIndex = i;
      newAppBundle.src = `${scripts[i].src}&${new Date().getTime()}`;
    }
  }

  oldAppBundle = document.getElementsByTagName('script')[oldScriptIndex];
  oldAppBundle.parentNode.removeChild(oldAppBundle);
  document.getElementsByTagName('body')[0].appendChild(newAppBundle);
}

configBlock.$inject = ['$stateProvider', '$urlRouterProvider', 'localStorageServiceProvider', '$locationProvider', '$translateProvider', 'IdleProvider', 'KeepaliveProvider',
                       'chatScript'];

export
default configBlock;



// WEBPACK FOOTER //
// ./app/app.configBlock.js